export const checkValidity = (value, rules) =>{
	let isValid = true;
	if (!rules){
		return true
	}
	if(rules.required){
		isValid = value.trim() !== '' && isValid;
	}
	if(rules.minLength){
		isValid = value.length >= rules.minLength && isValid
	}

  if(rules.email){
     var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isValid = re.test(value);
  }

	return isValid;
}



// WEBPACK FOOTER //
// ./src/shared/utility.js